// Librerías externas
import React from 'react';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import NavItem from 'react-bootstrap/NavItem';
import Navbar from 'react-bootstrap/Navbar';

// Módulos internos
import { TescuchaLogo } from './atoms/TescuchaLogo';
import { useAppDispatch, useAppSelector } from '../hooks/reduxHooks';
import { logout } from '../redux/admin/adminSlice';
import utils from '../utils';

import '../styles/Header.css';

const titleFixTEscucha = '';

const titleTEscucha = (
  <TescuchaLogo width={102} height={34} />
);
const Header = ({ basename }) => {
  const dispatch = useAppDispatch();
  const { isLogged, loginData } = useAppSelector(({ adminReducer }) => adminReducer);

  // Validar roles: debe tener ADMIN o ADMIN_DENUNCIAS y NO tener CONFIG
  const { user } = loginData;

  // Obtener roles del usuario - intentar desde userData primero, luego del token
  let roles = user?.userData?.roles || [];

  // Si no hay roles en userData, intentar obtenerlos del token
  if (roles.length === 0 && user?.token) {
    try {
      const tokenRoles = utils.getRoles();
      roles = tokenRoles || [];
    } catch (error) {
      // Si falla, mantener array vacío
      roles = [];
    }
  }

  // Normalizar roles a mayúsculas para comparación
  const normalizedRoles = roles.map((role) => String(role).toUpperCase().trim());

  // Verificar si tiene el rol CONFIG (no debe ver el header) - case insensitive
  const hasConfigRole = normalizedRoles.some(
    (role) => role === 'CONFIG' || role.includes('CONFIG')
  );

  // Verificar si tiene ADMIN o ADMIN_DENUNCIAS - case insensitive
  const hasAdminRole = normalizedRoles.some(
    (role) =>
      role === 'ADMIN' ||
      role === 'ADMIN_DENUNCIAS' ||
      role.includes('ADMIN') ||
      role.includes('ADMIN_DENUNCIAS')
  );

  const canShowAdminContent = isLogged && hasAdminRole && !hasConfigRole;
  // const logo = basename === '/fix-tescucha' ? logo_fixtescucha : logo_tescucha;
  const navbarColor = basename === '/fix-tescucha' ? '#d9d9d9' : '#ffffff'; // Color personalizado para fixtescucha
  const title = basename === '/fix-tescucha' ? titleFixTEscucha : titleTEscucha;
  // const logoWidth = basename === '/fix-tescucha' ? 80 : 30;
  // const logoHeight = basename === '/fix-tescucha' ? 'auto' : 'auto';
  const closeSession = () => {
    logout(dispatch);
    window.open(process.env.REACT_APP_ssoUrl, '_self');
  };

  return (
    <Navbar style={{ backgroundColor: navbarColor }} expand="lg" variant="light">
      <Link to="/" className="navbar-brand">
        <span className="txt-home">{title}</span>
      </Link>
      {canShowAdminContent && (
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
      )}
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mr-auto">
          {canShowAdminContent ? (
            <>
              <LinkContainer exact to="/bandeja/colaborador" className="nav-link" style={{ cursor: 'pointer', color: '#000', paddingBottom: '5px' }}>
                <NavItem>Bandeja de denuncias</NavItem>
              </LinkContainer>
              <LinkContainer exact to="/analiticas" className="nav-link" style={{ cursor: 'pointer', color: '#000', paddingBottom: '5px' }}>
                <NavItem>Reporte de interacción TEscucha</NavItem>
              </LinkContainer>
            </>
          ) : (
            ''
          )}
        </Nav>
        <Form inline>
          {user && roles.length > 0 && (
            <span
              style={{
                marginRight: '15px',
                fontSize: '12px',
                color: basename === '/fix-tescucha' ? '#000' : '#fff',
                padding: '5px 10px',
                backgroundColor: basename === '/fix-tescucha' ? '#f0f0f0' : 'rgba(255,255,255,0.2)',
                borderRadius: '4px',
              }}
              title="Roles del usuario"
            >
              Roles: {roles.join(', ')}
            </span>
          )}
          {canShowAdminContent ? (
            <Button
              variant={basename === '/fix-tescucha' ? 'outline-dark' : 'outline-dark'}
              size="sm"
              onClick={closeSession}
            >
              Salir
            </Button>
          ) : (
            ''
          )}
        </Form>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Header;
